import React from 'react';
import { WalteroCsvExportButton } from './waltero';

/**
 * Legacy Export Button Component - Backward Compatibility Wrapper
 * 
 * This component wraps the new WalteroExportButton to maintain backward compatibility
 * while providing enhanced functionality. For new implementations, use WalteroExportButton directly.
 * 
 * @deprecated Use WalteroExportButton or WalteroCsvExportButton instead
 */
const ExportButton = ({ 
  onClick, 
  disabled = false, 
  variant = 'outlined', 
  size = 'small',
  tooltip = 'Export table data to CSV',
  children = 'Export CSV',
  className = '',
  style = {},
  data,
  columns,
  filename,
  ...otherProps
}) => {
  // Handle legacy onClick prop by converting to data/columns if possible
  const handleLegacyExport = (format) => {
    if (onClick) {
      onClick();
    }
  };

  // If data is provided, use the new enhanced export
  if (data && columns) {
    return (
      <WalteroCsvExportButton
        data={data}
        columns={columns}
        filename={filename}
        variant={variant}
        size={size}
        disabled={disabled}
        className={className}
        sx={style}
        onExportComplete={handleLegacyExport}
        {...otherProps}
      />
    );
  }

  // Fallback to legacy behavior with new styling
  return (
    <WalteroCsvExportButton
      data={[]}
      columns={[]}
      filename={filename || 'export'}
      variant={variant}
      size={size}
      disabled={disabled}
      className={className}
      sx={style}
      customExporters={{
        csv: () => {
          if (onClick) {
            try {
              const result = onClick();
              // If onClick returns a promise, handle it
              if (result && typeof result.then === 'function') {
                return result;
              }
              // Legacy onClick handlers (like exportTableData) handle the download internally
              // and return boolean - pass through the boolean result directly
              return Boolean(result);
            } catch (error) {
              console.error('Export onClick handler failed:', error);
              return false;
            }
          }
          return false;
        }
      }}
      {...otherProps}
    >
      {children}
    </WalteroCsvExportButton>
  );
};

export default ExportButton; 